import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/green.png";
import fruit from "/cywe-assets/fruit/pear.png";

export default function Green({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="God is good, all the time, God is good!"
				description="Good is the combination of God’s care, kindness and joy. It's the grace of God that allows you to be GOOD. Maybe you can’t describe it exactly but at a given moment, you know that you are just fine."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/4"
				next="/experience/6"
			/>
		</>
	);
}
